import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';

import { TranslateModule } from '../translate/translate.module';
import { InputDialogComponent } from './input-dialog.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    MatInputModule,
    MatButtonModule,
    MatDialogModule,
    TranslateModule,
  ],
  exports: [
    InputDialogComponent,
  ],
  declarations: [
    InputDialogComponent,
  ],
  entryComponents: [
    InputDialogComponent,
  ],
})
export class ComponentsModule { }
